import { render, staticRenderFns } from "./AccountStatus.vue?vue&type=template&id=3dfd732e&scoped=true&"
import script from "./AccountStatus.vue?vue&type=script&lang=js&"
export * from "./AccountStatus.vue?vue&type=script&lang=js&"
import style0 from "./AccountStatus.vue?vue&type=style&index=0&id=3dfd732e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd732e",
  null
  
)

export default component.exports